import { useLocation, useSearchParams } from 'react-router-dom'
import { banSearch } from './bans'
import { scaleSearch } from './scales'

/** The categories that replay history, each with its own pages of everyone in it. */
const UNIVERSES = ['/f2', '/f15', '/reverse', '/ban', '/points', '/qualifying', '/fp']

/** The real pages a category draws again: drivers, constructors and races. */
const ENTITY = /^\/(drivers|constructors|races)\/./
const SEASON = /^\/seasons\/(\d{4})$/

/**
 * Where a link leads from the page being read. Callers name the real page
 * (`/constructors/mclaren`, `/seasons/1988`); inside a category it becomes
 * that category's page of it, with its bans or its points table carried
 * along. Anywhere else, and for any other page, the path is left as it is.
 */
export function useUniversePath(): (path: string) => string {
  const { pathname } = useLocation()
  const [params] = useSearchParams()
  const universe = UNIVERSES.find(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  )
  if (!universe) return (path) => path
  const search =
    universe === '/ban' ? banSearch(params) : universe === '/points' ? scaleSearch(params) : ''
  return (path) => {
    const season = SEASON.exec(path)
    if (season) return `${universe}/season?y=${season[1]}${search && `&${search.slice(1)}`}`
    return ENTITY.test(path) ? `${universe}${path}${search}` : path
  }
}
